import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import s from './ColorBlock.module.css';

class ColorBlock extends Component {

  static propTypes = {
    mediumRangeMinValue: PropTypes.number.isRequired,
    highRangeMinValue: PropTypes.number.isRequired,
    value: PropTypes.number,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    this.getClass = this.getClass.bind(this);
  }

  getClass() {
    const {
      value,
      mediumRangeMinValue,
      highRangeMinValue,
    } = this.props;

    if (value < 0 || value > 1) return null;
    if (highRangeMinValue && value >= highRangeMinValue) return s.rangeHigh;
    if (mediumRangeMinValue && value >= mediumRangeMinValue) return s.rangeMedium;

    return s.rangeLow;
  }

  render() {
    const {
      children,
      className,
      value, // eslint-disable-line no-unused-vars
      mediumRangeMinValue, // eslint-disable-line no-unused-vars
      highRangeMinValue, // eslint-disable-line no-unused-vars
      ...props
    } = this.props;
    const classes = clsx(
        s.colorBlock,
        className,
        this.getClass(),
    );
    return <div className={classes} {...props}>{children}</div>;
  }
}

export default ColorBlock;
